import cx from 'clsx';
import React from 'react';
import { Tooltip } from 'react-tooltip';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

interface IProps {
  id: string;
}

const TooltipHardwareOverview: React.FC<IProps> = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      id={id}
      className={style.hardwareOverviewTooltip}
      place={'bottom-start'}
      render={({ content }) => {
        if (!content) {
          return null;
        }

        const info = JSON.parse(content);

        return (
          <div className={style.hardwareOverviewTooltipInfo}>
            <div className={style.infoHead}>
              <span className={style.infoTotal}>{t('Total')}</span>{' '}
              <span>
                {info.countAiItems} {t('of')} {info.countItems} {t('with active AI')}
              </span>
            </div>
            <div className={style.infoItem}>
              <div className={style.infoItemCritical}>
                {info.countAiItemsUrgencyCritical} <span>{t('Critical AI')}</span>
              </div>
            </div>
            <div className={style.infoItem}>
              <div className={style.infoItemHigh}>
                {info.countAiItemsUrgencyHigh} <span>{t('High AI')}</span>
              </div>
            </div>
            <div className={style.infoItem}>
              <div className={style.infoItemStandard}>
                {info.countAiItemsUrgencyStandard} <span>{t('Standard AI')}</span>
              </div>
            </div>
          </div>
        );
      }}
    />
  );
};

export default TooltipHardwareOverview;
